export default "<m-cylinder\n    color=\"purple\"\n    x=\"3\"\n    y=\"2\"\n    z=\"3\"\n></m-cylinder>\n";